<template>
	<div class="content_main">
		<a-tabs default-active-key="a" @change="callback">
			<a-tab-pane key="a" tab="各分公司固定资产变化趋势">
				<div class="content_main o_s">
					<div class="top">
						<div class="top_item">
							<span>公司</span>
							<a-select placeholder="请选择公司" v-model="tab_1.company" @change="handleChange" style="width: 120px" >
								<a-select-option :value="item.value" v-for="(item, idx) in companys" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>部门</span>
							<a-select @change="handleChangeDept()" allowClear placeholder="请选择部门" :disabled="tab_1.company == 0" v-model="tab_1.dept"
							 style="width: 120px">
								<a-select-option :value="item.value" v-for="(item, idx) in depts" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>统计维度</span>
							<a-select @change="handleChange" placeholder="请选择" v-model="tab_1.money" style="width: 120px">
								<a-select-option :value="item.value" v-for="(item, idx) in mons" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>物品状态</span>
							<a-select @change="handleChange" placeholder="全部" allowClear v-model="tab_1.status" style="width: 120px">
								<a-select-option :value="index" v-for="(item, index) in statusMap3" :key="index">{{ item }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>统计开始日期</span>
							<a-date-picker @change="handleChange" allowClear style="width: 120px" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
							 v-model="tab_1.startTime" placeholder="请选择" />
						</div>
						<div class="top_item">
							<span>统计结束日期</span>
							<a-date-picker @change="handleChange" allowClear style="width: 120px" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
							 v-model="tab_1.endTime" placeholder="请选择" />
						</div>
					</div>
					<div class="test" id="test"></div>
				</div>
			</a-tab-pane>
			<a-tab-pane key="b" tab="各公司/部门固定资产占比分析">
				<div class="content_main o_s">
					<div class="top">
						<div class="top_item">
							<span>公司</span>
							<a-select placeholder="请选择公司" v-model="tab_2.company" @change="handleChange2" style="width: 120px">
								<a-select-option :value="item.value" v-for="(item, idx) in companys" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>统计维度</span>
							<a-select @change="handleChange2" placeholder="请选择部门" v-model="tab_2.money" style="width: 120px">
								<a-select-option :value="item.value" v-for="(item, idx) in mons" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>物品状态</span>
							<a-select @change="handleChange2" placeholder="全部" allowClear v-model="tab_2.status" style="width: 120px">
								<a-select-option :value="idx" v-for="(item, idx) in statusMap3" :key="idx">{{ item }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>统计开始日期</span>
							<a-date-picker @change="handleChange2" allowClear style="width: 120px" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
							 v-model="tab_2.startTime" placeholder="请选择" />
						</div>
						<div class="top_item">
							<span>统计结束日期</span>
							<a-date-picker @change="handleChange2" allowClear style="width: 120px" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
							 v-model="tab_2.endTime" placeholder="请选择" />
						</div>
					</div>
					<div class="test" id="charts2"></div>
					<div class="test" id="charts3"></div>
				</div>
			</a-tab-pane>
			<a-tab-pane key="c" tab="各公司总资产变化趋势">
				<div class="content_main o_s">
					<div class="top">
						<div class="top_item">
							<span>公司</span>
							<a-select placeholder="请选择公司" v-model="tab_3.company" @change="handleChange3" style="width: 120px">
								<a-select-option :value="item.value" v-for="(item, idx) in companys" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>部门</span>
              <!-- :disabled="tab_3.company == 0" -->
							<a-select @change="handleChangeDept3" allowClear placeholder="请选择部门"  v-model="tab_1.dept" disabled
							 style="width: 120px">
								<a-select-option :value="item.value" v-for="(item, idx) in depts" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>统计维度</span>
							<a-select @change="handleChange3" placeholder="请选择" v-model="tab_3.money" style="width: 120px">
								<a-select-option :value="item.value" v-for="(item, idx) in mons" :key="idx">{{ item.label }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>物品状态</span>
							<a-select @change="handleChange3" placeholder="全部" allowClear v-model="tab_3.status" style="width: 120px">
								<a-select-option :value="index" v-for="(item, index) in statusMap3" :key="index">{{ item }}
								</a-select-option>
							</a-select>
						</div>
						<div class="top_item">
							<span>统计开始日期</span>
							<a-date-picker @change="handleChange3" allowClear style="width: 120px" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
							 v-model="tab_3.startTime" placeholder="请选择" />
						</div>
						<div class="top_item">
							<span>统计结束日期</span>
							<a-date-picker @change="handleChange" allowClear style="width: 120px" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD"
							 v-model="tab_3.endTime" placeholder="请选择" />
						</div>
					</div>
					<div class="test" id="charts4"></div>
					<div class="test" id="charts5"></div>
				</div>
			</a-tab-pane>
		</a-tabs>
	</div>
</template>

<script>
	import {
		// get_total_value,
		// get_value_proportion,
		// sku_get_total_value,
		// asset_get_total_price,
    fixedAssetsAnalysis,
    assetsContrastMonth,
    assetsContrast,
    fixedAssetsChange,
		// sku_get_total_price,
		asset_get_price_proportion,
	} from '@/api/system'
	import {
		returnDept
	} from '@/utils/unit_axios'
	export default {
		data() {
			return {
				tabs: {
					a: true,
					b: false,
					c: false,
				},
				tab_1: {
					company: ' ',
					dept: undefined,
					money: 0,
					status: undefined,
					startTime: '',
					endTime: '',
				},
				tab_2: {
					company: ' ',
					startTime: '',
					money: 0,
					status: undefined,
					endTime: '',
				},
				tab_3: {
					company: ' ',
					dept: undefined,
					money: 0,
					status: undefined,
					startTime: '',
					endTime: '',
				},
				companys: [],
				depts: [],
				depts3: [],
				mons: [{
						value: 0,
						label: '按采购价',
					},
					{
						value: 1,
						label: '按估值价',
					},
				],
			}
		},
		created() {},
		mounted() {
			returnDept((res) => {
				res.depts.unshift({
					children: [],
					key: 0,
					label: '所有公司',
					value: ' ',
				})
				this.companys = res.depts
			})
			this.get_charts1()
		},
		methods: {
			callback(key) {
				if (!this.tabs[key]) {
					this.tabs[key] = true
					this.$nextTick(() => {
						switch (key) {
							case 'b':
								this.get_charts2()
								break
							case 'c':
								this.get_charts3()
								break
						}
					})
				}
			},
			handleChangeDept() {
				this.companys.forEach((element) => {
					if (element.value == this.tab_1.company) {
						this.depts = element.children
						this.get_charts1()
					}
				})
			},
			handleChange() {
				this.tab_1.dept = undefined
				this.companys.forEach((element) => {
					if (element.value == this.tab_1.company) {
						this.depts = element.children
						this.get_charts1()
					}
				})
			},

			handleChange2() {
				this.companys.forEach((element) => {
					if (element.value == this.tab_2.company) {
						this.depts = element.children
						this.get_charts2()
					}
				})
			},
			handleChangeDept3() {
				this.companys.forEach((element) => {
					if (element.value == this.tab_3.company) {
						this.depts = element.children
						this.get_charts3()
					}
				})
			},
			handleChange3() {
				this.tab_3.dept = undefined
				this.companys.forEach((element) => {
					if (element.value == this.tab_3.company) {
						this.depts3 = element.children
						this.get_charts3()
					}
				})
			},
			//第一个图表
			get_charts1() {
				// if (this.tab_1.money == 2) {
					// asset_get_total_price
          // fixedAssetsAnalysis
          fixedAssetsChange({
            dimension: this.tab_1.money,
						companyId:this.tab_1.company ? this.tab_1.company : null,
						deptId: this.tab_1.dept ? this.tab_1.dept : null,
						state:this.tab_1.status,
						startTime: this.tab_1.startTime,
						endTime: this.tab_1.endTime,
					}).then((res) => {
						var lis = res.data
						var month = []
						var vals = []
						lis.forEach((item) => {
							month.push(item.month)
							vals.push(item.total)
						})
						month = month.reverse()
						vals = vals.reverse()
						var dom = document.getElementById('test')
						var myChartNowMonth = this.$echarts.init(dom)
						var option = {
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									type: 'cross',
									crossStyle: {
										color: '#999',
									},
								},
							},
							dataZoom: [{
									type: 'slider',
									show: true,
									start: 1,
									end: 20,
									bottom: -10,
									height: 20,
									zoomLock: false,
									xAxisIndex: [0],
									zoomLock: true,
								},
								{
									type: 'inside',
									show: true,
									xAxisIndex: [0],
									start: 1,
									end: 30,
								},
							],
							toolbox: {
								feature: {
									dataView: {
										show: true,
										readOnly: false
									},
									magicType: {
										show: true,
										type: ['line', 'bar']
									},
									restore: {
										show: true
									},
									saveAsImage: {
										show: true
									},
								},
							},
							legend: {
								data: ['柱状图', '折线图'],
							},
							xAxis: [{
								type: 'category',
								data: month,
								axisPointer: {
									type: 'shadow',
								},
							}, ],
							yAxis: [{
									type: 'value',
									min: 0,
								},
								{
									type: 'value',
									min: 0,
								},
							],
							series: [{
									name: '柱状图',
									barWidth: 30, //柱图宽度
									type: 'bar',
									data: vals,
								},

              {
                name: '折线图',
                type: 'line',
                yAxisIndex: 1,
                data: vals,
              },
            ],
          }
          option && myChartNowMonth.setOption(option)
        })
      // }
    },
    //获取第二项图表
    get_charts2() {
      // if (this.tab_2.money == 1) {
      //   get_value_proportion({
      //     deptId: this.tab_2.company,
      //     startTime: this.tab_2.startTime,
      //     endTime: this.tab_2.endTime,
      //   }).then((res) => {
      //     var lis = res.data
      //     var ts = []
      //     var vals = []
      //     lis.forEach((item) => {
      //       ts.push(item.dept_name)
      //       vals.push(item.value)
      //       item['name'] = item.dept_name
      //     })
      //     var dom = document.getElementById('charts2')
      //     var myChartNowMonth = this.$echarts.init(dom)
      //     let option = {
      //       title: {
      //         text: '固定资产对比',
      //       },
      //       tooltip: {
      //         trigger: 'axis',
      //         axisPointer: {
      //           type: 'shadow',
      //         },
      //       },
      //       legend: {},
      //       grid: {
      //         left: '3%',
      //         right: '4%',
      //         bottom: '3%',
      //         containLabel: true,
      //       },
      //       xAxis: {
      //         type: 'value',
      //         boundaryGap: [0, 0.01],
      //       },
      //       yAxis: {
      //         type: 'category',
      //         data: ts,
      //       },
      //       series: [
      //         {
      //           name: '固定资产',
      //           type: 'bar',
      //           data: vals,
      //         },
      //       ],
      //     }
      //     option && myChartNowMonth.setOption(option)
      //     var dom2 = document.getElementById('charts3')
      //     var myChartNowMonth = this.$echarts.init(dom2)
      //     let option2 = {
      //       title: {
      //         text: '固定资产比例',
      //         left: 'center',
      //       },
      //       tooltip: {
      //         trigger: 'item',
      //       },
      //       legend: {
      //         orient: 'vertical',
      //         left: 'left',
      //       },
      //       series: [
      //         {
      //           name: '占比',
      //           type: 'pie',
      //           radius: '55%',
      //           left: '30%',
      //           data: lis,
      //           itemStyle: {
      //             normal: {
      //               label: {
      //                 show: true,
      //                 formatter: '{d}%',
      //               },
      //               labelLine: { show: true },
      //             },
      //           },
      //         },
      //       ],
      //     }
      //     option2 && myChartNowMonth.setOption(option2)
      //   })
      // } else {
        // asset_get_price_proportion
        fixedAssetsAnalysis({
          state:this.tab_2.status,
          dimension: this.tab_2.money,
          companyId: this.tab_2.company,
          startTime: this.tab_2.startTime,
          endTime: this.tab_2.endTime,
        }).then((res) => {
          var lis = res.data
          var ts = []
          var vals = []
          lis.forEach((item) => {
            item['value']=item.purchasePrice
            ts.push(item.companyName)
            vals.push(item.purchasePrice)
            item['name'] = item.companyName
          })
          var dom = document.getElementById('charts2')
          var myChartNowMonth = this.$echarts.init(dom)
          let option = {
            title: {
              text: '固定资产对比',
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
              },
            },
            legend: {},
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
            },
            xAxis: {
              type: 'value',
              boundaryGap: [0, 0.01],
            },
            yAxis: {
              type: 'category',
              data: ts,
            },
            series: [
              {
                name: '固定资产',
                type: 'bar',
                data: vals,
              },
            ],
          }
          option && myChartNowMonth.setOption(option)
          var dom2 = document.getElementById('charts3')
          var myChartNowMonth = this.$echarts.init(dom2)
          let option2 = {
            title: {
              text: '固定资产比例',
              left: 'center',
            },
            tooltip: {
              trigger: 'item',
            },
            legend: {
              orient: 'vertical',
              left: 'left',
            },
            series: [
              {
                name: '占比',
                type: 'pie',
                radius: '55%',
                left: '30%',
                data: lis,
                itemStyle: {
                  normal: {
                    label: {
                      show: true,
                      formatter: '{d}%',
                    },
                    labelLine: { show: true },
                  },
                },
              },
            ],
          }
          option2 && myChartNowMonth.setOption(option2)
        })
      // }
    },
    //获取第三项图表
    get_charts3() {
      // console.log(this.tab_3.money, 'this.tab_3.money============================')
      // if (this.tab_3.money == 1) {
      //   // sku_get_total_value
      //   assetsContrast({
      //     companyId: this.tab_3.dept ? this.tab_3.dept : this.tab_3.company,
      //     startTime: this.tab_3.startTime,
      //     endTime: this.tab_3.endTime,
      //   }).then((res) => {
      //     var lis = res.data
      //     var title = []
      //     var vals = []
      //     lis.forEach((item) => {
      //       title.push(item.month)
      //       vals.push(item.total)
      //     })
      //     get_total_value({
      //       dept_id: this.tab_1.dept ? this.tab_1.dept : this.tab_1.company,
      //       start_date: this.tab_1.startTime,
      //       end_date: this.tab_1.endTime,
      //     }).then((rs) => {
      //       var list = rs.data
      //       var vals_ = []
      //       var alls = []
      //       var all_1 = [lis[lis.length-1].total] //流动
      //       var all_2 = [list[list.length-1].total] //固定
      //       list.forEach((item, idx) => {
      //         vals_.push(item.total)
      //         alls.push(item.total + lis[idx].total)
      //       })
      //       var dom = document.getElementById('charts5')
      //       var charts = this.$echarts.init(dom)
      //       let option2 = {
      //         title: {
      //           text: '资产趋势',
      //         },
      //         tooltip: {
      //           trigger: 'axis',
      //         },
      //         dataZoom: [
      //           {
      //             type: 'slider',
      //             show: true,
      //             start: 0,
      //             end: 50,
      //             bottom: -10,
      //             height: 20,
      //             xAxisIndex: [0],
      //             zoomLock: true,
      //           },
      //         ],
      //         legend: {
      //           data: ['流动资产', '固定资产', '总资产'],
      //         },
      //         grid: {
      //           left: '3%',
      //           right: '4%',
      //           bottom: '3%',
      //           containLabel: true,
      //         },
      //         toolbox: {
      //           feature: {
      //             saveAsImage: {},
      //           },
      //         },
      //         xAxis: {
      //           type: 'category',
      //           boundaryGap: false,
      //           data: title,
      //         },
      //         yAxis: {
      //           type: 'value',
      //         },
      //         series: [
      //           {
      //             name: '流动资产',
      //             type: 'line',
      //             data: vals,
      //           },
      //           {
      //             name: '固定资产',
      //             type: 'line',
      //             data: vals_,
      //           },
      //           {
      //             name: '总资产',
      //             type: 'line',
      //             data: alls,
      //           },
      //         ],
      //       }
      //       option2 && charts.setOption(option2)
      //       var dom = document.getElementById('charts4')
      //       var myChartNowMonth = this.$echarts.init(dom)
      //       let option1 = {
      //         title: {
      //           text: '资产对比',
      //           left: 'center',
      //         },
      //         tooltip: {
      //           trigger: 'item',
      //         },
      //         legend: {
      //           orient: 'vertical',
      //           left: 'left',
      //         },
      //         series: [
      //           {
      //             name: '资产分析',
      //             type: 'pie',
      //             radius: '50%',
      //             data: [
      //               { value: all_2, name: '固定资产' },
      //               { value: all_1, name: '流动资产' },
      //             ],
      //             itemStyle: {
      //               normal: {
      //                 label: {
      //                   show: true,
      //                   formatter: '{d}%',
      //                 },
      //                 labelLine: { show: true },
      //               },
      //             },
      //           },
      //         ],
      //       }
      //       option1 && myChartNowMonth.setOption(option1)
      //     })

      //     console.log(res)
      //   })
      // } else {
        assetsContrastMonth({
          state:this.tab_3.status,
          dimension: this.tab_3.money,
          compantId: this.tab_3.dept ? this.tab_3.dept : this.tab_3.company,
          startTime: this.tab_3.startTime,
          endTime: this.tab_3.endTime,
        }).then((res) => {
          var lis = res.data
          var title = []
          var vals = []
          var assetList = []
          var flowAssetList = []
          var totalAssetList = []
          // 固定资产 assetList
          //流动资产 flowAssetList
          //总资产 totalAssetList
          res.data.assetList.forEach((item) => {
            title.push(item.month)
            assetList.push(item.total)
          })
           res.data.flowAssetList.forEach((item) => {
        
            flowAssetList.push(item.total)
          })
           res.data.totalAssetList.forEach((item) => {
          
            totalAssetList.push(item.total)
          })
          //初始化
            var dom = document.getElementById('charts5')
            var charts = this.$echarts.init(dom)
            var option2
            option2 = {
              title: {
                text: '资产趋势',
              },
              tooltip: {
                trigger: 'axis',
              },
              dataZoom: [
                {
                  type: 'slider',
                  show: true,
                  start: 0,
                  end: 50,
                  bottom: -10,
                  height: 20,
                  xAxisIndex: [0],
                  zoomLock: true,
                },
              ],
              legend: {
                data: ['流动资产', '固定资产', '总资产'],
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true,
              },
              toolbox: {
                feature: {
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: title,
              },
              yAxis: {
                type: 'value',
              },
              series: [
                {
                  name: '流动资产',
                  type: 'line',
                  data: assetList,
                },
                {
                  name: '固定资产',
                  type: 'line',
                  data: flowAssetList,
                },
                {
                  name: '总资产',
                  type: 'line',
                  data: totalAssetList,
                },
              ],
            }
            option2 && charts.setOption(option2)
          // var title = []
          // var vals = []
          // lis.forEach((item) => {
          //   title.push(item.month)
          //   vals.push(item.total)
          // })
          // fixedAssetsChange({
          //   compantId: this.tab_3.dept ? this.tab_3.dept : this.tab_3.company,
          //   startTime: this.tab_3.startTime,
          //   endTime: this.tab_3.endTime,
          // }).then((rs) => {
          //   var list = rs.data
          //   var vals_ = []
          //   var alls = []
          //   var all_1 = [lis[lis.length-1].total] //流动
          //   var all_2 = [list[list.length-1].total] //固定
          //   list.forEach((item, idx) => {
          //     vals_.push(item.total)
          //     alls.push(item.total + lis[idx].total)
          //   })
          //   var dom = document.getElementById('charts5')
          //   var charts = this.$echarts.init(dom)
          //   let option2 = {
          //     title: {
          //       text: '资产趋势',
          //     },
          //     tooltip: {
          //       trigger: 'axis',
          //     },
          //     dataZoom: [
          //       {
          //         type: 'slider',
          //         show: true,
          //         start: 0,
          //         end: 50,
          //         bottom: -10,
          //         height: 20,
          //         xAxisIndex: [0],
          //         zoomLock: true,
          //       },
          //     ],
          //     legend: {
          //       data: ['流动资产', '固定资产', '总资产'],
          //     },
          //     grid: {
          //       left: '3%',
          //       right: '4%',
          //       bottom: '3%',
          //       containLabel: true,
          //     },
          //     toolbox: {
          //       feature: {
          //         saveAsImage: {},
          //       },
          //     },
          //     xAxis: {
          //       type: 'category',
          //       boundaryGap: false,
          //       data: title,
          //     },
          //     yAxis: {
          //       type: 'value',
          //     },
          //     series: [
          //       {
          //         name: '流动资产',
          //         type: 'line',
          //         data: vals,
          //       },
          //       {
          //         name: '固定资产',
          //         type: 'line',
          //         data: vals_,
          //       },
          //       {
          //         name: '总资产',
          //         type: 'line',
          //         data: alls,
          //       },
          //     ],
          //   }
            // option2 && charts.setOption(option2)
        assetsContrast({
          state:this.tab_3.status,
          dimension: this.tab_3.money,
          companyId: this.tab_3.dept ? this.tab_3.dept : this.tab_3.company,
          startTime: this.tab_3.startTime,
          endTime: this.tab_3.endTime,
        }).then((res) => {
            var all_1 = res.data.asset //流动
            var all_2 = res.data.flowAsset //固定
            var dom = document.getElementById('charts4')
            var myChartNowMonth = this.$echarts.init(dom)
            let option1 = {
              title: {
                text: '资产对比',
                left: 'center',
              },
              tooltip: {
                trigger: 'item',
              },
              legend: {
                orient: 'vertical',
                left: 'left',
              },
              series: [
                {
                  name: '资产分析',
                  type: 'pie',
                  radius: '50%',
                  data: [
                    { value: all_2, name: '固定资产' },
                    { value: all_1, name: '流动资产' },
                  ],
                  itemStyle: {
                    normal: {
                      label: {
                        show: true,
                        formatter: '{d}%',
                      },
                      labelLine: { show: true },
                    },
                  },
                },
              ],
            }
            option1 && myChartNowMonth.setOption(option1)
          })
        })
      // }
    },
  },
}
</script>

<style scoped lang='less'>
	.test {
		width: 100%;
		height: calc(100% - 50px);
		float: left;
	}

	.o_s {
		padding-bottom: 15px;
	}

	.top {
		width: 100%;
		float: left;
		margin-bottom: 15px;
		margin-top: 10px;

		.top_item {
			float: left;
			margin-right: 15px;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			span {
				margin-right: 10px;
			}
		}
	}

	.charts {
		width: 100%;
		height: calc(100% - 50px);
		float: left;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.o_charts {
			width: 49%;
			height: 100%;
			float: left;
		}
	}
</style>
